/**
 * Duro as a design-system module — the first implementation of the
 * ds-contract, and the default for every site. Its id matches theme-engine's
 * `duro` DesignSystem (default brand and tokens): that shared id is what ties
 * a site's components to its theme.
 */
import {
  Button,
  LinkButton,
  Heading,
  Text,
  Card,
  Inline,
  Input,
  InputGroup,
  Icon,
} from "@duro-app/ui";
import {
  CONTRACT_VERSION,
  REACT_MAJOR,
  type DesignSystemModule,
} from "@website-builder/ds-contract";
import { DEFAULT_DESIGN_SYSTEM_ID } from "@website-builder/theme-engine";

export const duroModule: DesignSystemModule = {
  contractVersion: CONTRACT_VERSION,
  id: DEFAULT_DESIGN_SYSTEM_ID,
  name: "Duro",
  reactMajor: REACT_MAJOR,
  components: {
    Button,
    LinkButton,
    Heading,
    Text,
    Card,
    Inline,
    Input,
    InputGroup: { Root: InputGroup.Root, Addon: InputGroup.Addon },
    Icon,
  },
};
